import React, { useState } from 'react';
import ListWithShowMoreLess from 'src/Admin/components/common/ListWithShowMoreLess';
import {
  TrashIcon,
  TrashIconDisable,
} from '../../../../../img/findcare/FindCareSVG';
import './brokerview.scss';

const BrokerViewPanel = ({
  selectedBrokers = [],
  onTrashButtonClickHandler = null,
  editAffiliatedRecords,
}) => {
  const [showMoreBrokers, setShowMoreBrokers] = useState(false);

  const RenderBrokerListItem = ({ data, index }) => {
    const broker = data;
    return (
      <div className="selected-broker-item">
        <div className="d-flex broker-card">
          <div className="flex-1">
            <div>
              <span className="blob-item-name-1">{broker.BrokerName}</span>
            </div>
            <div className="blob-item-desc-1">
              Type: {broker.BrokerTypeDesc}{' '}
              {broker?.ParentBrokerCode &&
                `| Parent : ${broker?.ParentBrokerCode}`}
            </div>
          </div>
          <div>
            <div className="d-dlex">
              <div className="blob-item-desc-2">ID: {broker.Code}</div>
              <div className="blob-item-desc-3">
                {broker.TaxID && (
                  <div className="blob-item-desc-3">Tax: {broker.TaxID}</div>
                )}
              </div>
            </div>
          </div>
          {onTrashButtonClickHandler ? (
            editAffiliatedRecords ? (
              <div className="trash-icon-div">
                <button
                  type="button"
                  className="trash-button"
                  onClick={() => onTrashButtonClickHandler(broker.Code)}
                >
                  <TrashIcon />
                </button>
              </div>
            ) : (
              <div className="trash-icon-div">
                <button type="button" className="trash-button">
                  <TrashIconDisable />
                </button>
              </div>
            )
          ) : null}
        </div>
      </div>
    );
  };

  return (
    //selectedBrokers ? selectedBrokers.map((broker,index) =>

    //) : null
    selectedBrokers?.length > 0 ? (
      <ListWithShowMoreLess
        data={selectedBrokers}
        RenderItemComponent={RenderBrokerListItem}
        showMore={showMoreBrokers}
        setShowMore={setShowMoreBrokers}
        showMoreLabel={'Brokers'}
      />
    ) : null
  );
};

export default BrokerViewPanel;
